const Menu = [
  {
    label: "Home",
    pathname: "/"
  },
  {
    label: "Dashboard",
    pathname: "/dashboard"
  },
  {
    label: "Signup",
    pathname: "/signup"
  },
  {
    label: "Wizard",
    pathname: "/wizard"
  },
  {
    label: "Cards",
    pathname: "/cards"
  }

];

export default Menu;